import * as Events from '@shoflo/studio-redux/constants/SocketEvents';
import BaseSocketDispatcher from '@shoflo/studio-redux/SocketDispatcher';
import { MIXER_TASK_FAILED } from '@studio/constants';
import _ from 'underscore';

import {
  cancelAttendeeScreen,
  removeAttendeeScreen,
  processRealTimeMessage,
  knockUpdated,
  mixerTaskFailed,
  programChanged,
  socketConnected,
  socketDisconnected,
  socketReconnected,
} from './handlers';

class SocketDispatcher extends BaseSocketDispatcher {
  /**
   * Register app-specific event-handlerFn mappings here. You may override
   * any mappings defined in the _defaultEventHandlerMap.
   *
   * @type {Object.<{"string": function(store, data): void}>}
   */

  _appEventHandlerMap = {
    [Events.REAL_TIME]: processRealTimeMessage,
    [Events.ATTENDEE_SCREEN_SHARE_REMOVED]: removeAttendeeScreen,
    [Events.ATTENDEE_SCREEN_SHARE_CANCELLED]: cancelAttendeeScreen,
    [Events.KNOCK_UPDATED]: knockUpdated,
    [Events.BROADCAST_PROGRAM_CHANGED]: programChanged,
    [Events.BROADCAST_PROGRAM_SYNCED]: programChanged,
    [Events.CONNECT]: socketConnected,
    [Events.DISCONNECT]: socketDisconnected,
    [Events.RECONNECT]: socketReconnected,
    [Events.ATTENDEE_LEFT]: _.debounce(removeAttendeeScreen, 2000),
    [MIXER_TASK_FAILED]: mixerTaskFailed,
  };
}

export default SocketDispatcher;
